import { render, staticRenderFns } from "./briefcaseStorageBreakdown.html?vue&type=template&id=c364587c&scoped=true&external"
import script from "./briefcaseStorageBreakdown.js?vue&type=script&lang=js&external"
export * from "./briefcaseStorageBreakdown.js?vue&type=script&lang=js&external"
import style0 from "./briefcaseStorageBreakdown.scss?vue&type=style&index=0&id=c364587c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c364587c",
  null
  
)

export default component.exports